import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs'
import { IPartnerRecord } from 'clickNgo/entities/partner/models'
import { IJBPMyPartnersView } from 'clickNgo/models/crud/views'

export const mapPartnerRecordFromJBPMyPartners = (data: IJBPMyPartnersView): IPartnerRecord => ({
  id: data.PartnerId || '',
  name: data.PartnerName || '',
  communicationName: data.PartnerName || '',
  country: data.Country || '',
  email: data.Email || '',
  hierarchyType: data.HierarchyType || PartnerHierarchyType.HEADQUARTERS,
  isTopPartner: Boolean(data.IsTopPartner),
  parentPartnerId: data.PartnerPartnerId || '',
  partnerId: data.PartnerId || '',
  topPartnerId: data.TopPartnerId || '',
  isAcknowledged: Boolean(data.IsAcknowledged),
  isGlobalPartner: Boolean(data.IsGlobalPartner),
  isWWTopPartner: Boolean(data.IsWWTopPartner),
  isMarketTopPartner: Boolean(data.IsMarketTopPartner),
  isStrategicServicePartner: Boolean(data.IsStrategicServicePartner),
  topPartnerInfo: data.TopPartnerInfo || '',
  strategicServicePartnerInfo: data.StrategicServicePartnerInfo || '',
  completeness: data.Completeness || 0,
  sourceName: data.SourceName || 'Partner360',
  locationId: data.LocationID || '',
})
